import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditBillingShiftDifferentialRows,
  selectEditPayrollShiftDifferentialRows,
  selectIsEditMod,
  selectShiftDifferentialDescriptionTypeError,
  selectShiftDifferentialDescriptionTypes,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { makeStyles } from 'tss-react/mui';
import { findIndex, findRow } from '../Utils';
import { modsEnums } from 'app/models/Placement/PlacementMods';

interface GridCellProps {
  [key: string]: any;
}

const useStyles = makeStyles()(() => ({
  inputFields: {
    '& .MuiInputBase-input.MuiFilledInput-input': {
      paddingTop: '10px',
    },
  },
}));

export const EditDescriptionTypeCell = (props: any) => {
  return <EditType cellParams={props?.cellParams} currentMod={props?.currentMod} />;
};

const EditType = React.memo(function EditType(params: GridCellProps) {
  const dispatch = useDispatch();
  const [shiftDifferentialDescriptionType, setShiftDifferentialDescriptionType] = useState(
    params?.cellParams?.row?.shiftDifferentialDescriptionType,
  );
  const { classes } = useStyles();
  const { control } = useFormContext();
  const isModEdit = useSelector(selectIsEditMod);
  const options = useSelector(selectShiftDifferentialDescriptionTypes);

  const rowId = params?.cellParams?.id;
  //@Team : @Lakshmi - Please remove the use selectors to be used conditionally
  const shiftDiffEditRequests =
    params?.currentMod === modsEnums.PayrollShiftDifferential
      ? useSelector(selectEditPayrollShiftDifferentialRows)
      : useSelector(selectEditBillingShiftDifferentialRows);
  const descriptionTypeErrors = useSelector(selectShiftDifferentialDescriptionTypeError);

  useEffect(() => {
    if (params?.cellParams?.error !== null && params?.cellParams?.error !== undefined) {
      const val = descriptionTypeErrors?.filter(el => el.id === params?.cellParams?.id);
      const arr = descriptionTypeErrors?.length > 0 ? descriptionTypeErrors?.slice(0) : [];

      if (val?.length === 0) {
        const valueObj = { descriptionType: params?.cellParams?.error, id: params?.cellParams?.id };
        arr.push(valueObj);
      } else {
        const currentObj = arr.find(val => val.id === params?.cellParams?.id);
        const updatedObj = { ...currentObj, descriptionType: params?.cellParams?.error };
        const editIndex = arr.findIndex(val => val.id === params?.cellParams?.id);

        arr[editIndex] = updatedObj;
      }

      dispatch(placementModsAction.setShiftDifferentialDescriptionTypeError(arr));
    }
  }, [params?.cellParams?.error]);

  const setDescriptionTypeForEdit = data => {
    setShiftDifferentialDescriptionType(data);
    const shiftDiffEditRow = findRow(params, shiftDiffEditRequests, rowId);
    const updatedCell = {
      ...shiftDiffEditRow,
      shiftDifferentialDescriptionType: data,
      shiftDifferentialDescriptionTypeId: parseInt(options.find(el => el.Description === data)?.ID),
    };

    const editDateIndex = findIndex(updatedCell, params, shiftDiffEditRequests, rowId);
    let newRow = shiftDiffEditRequests.slice(0);
    newRow[editDateIndex] = updatedCell;
    switch (params?.currentMod) {
      case modsEnums.PayrollShiftDifferential: {
        dispatch(placementModsAction.setEditPayrollShiftDiffRows(newRow));
        break;
      }
      case modsEnums.BillingShiftDifferential: {
        dispatch(placementModsAction.setEditBillingShiftDiffRows(newRow));
        break;
      }
    }
  };

  return (
    <>
      <Controller
        name={`shiftDiffRequests${rowId}.descriptionTypes`}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value, ...rest } }) => (
          <FormInputDropdown
            name={'shiftDiffRequests.shiftDifferentialDescriptionType'}
            require={true}
            standard={true}
            options={options ?? []}
            inputValue={shiftDifferentialDescriptionType ?? null}
            readOnly={!isModEdit}
            handleChange={e => {
              setDescriptionTypeForEdit(e.target.value);
              dispatch(placementModsAction.setCustomTemplateType(true));
              dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
            }}
            customClass={classes.inputFields}
          ></FormInputDropdown>
        )}
      />
    </>
  );
});
